var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-scroll-inner",class:{
    'flow-text': _vm.flowText,
    'flex-height': _vm.flex,
    flex: _vm.flex,
    'flex-col': _vm.flex
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }